import { message } from "antd";
import { updateDocumentStatus } from "../../api/api";
import { Button } from "../styles/Button.styled";
import DeferDocumentSendingEmail from "./DeferDocumentSendingEmail";
import DepositAlternative from "./DepositAlternative";
import { useTranslation } from "react-i18next";

const DeferDocumentUpload = ({ setModelContent, enrollmentId }) => {
  const { t, i18n } = useTranslation("enrollment");
  const lang = i18n.language;

  return (
    <div>
      <DepositAlternative hideHeader />
      <div style={{ display: "flex", justifyContent: "center", gap: 20 }}>
        <Button
          style={{
            marginRight: "1rem",
            background: "transparent",
            color: "#253f66",
          }}
          onClick={() => {
            setModelContent({
              id: "initial-screen",
              title: t("Alternatives to Paying a Deposit"),
              component: <DepositAlternative />,
            });
          }}
        >
          {t("Cancel")}
        </Button>

        <Button
          onClick={async () => {
            await updateDocumentStatus(enrollmentId, "waiver-defer", lang).then(
              (res) => {
                if (res?.status === 200) {
                  message.success(
                    res?.message ||
                      "Email for document upload sent successfully"
                  );
                  setModelContent({
                    id: "defer-document-sending-email",
                    title: (
                      <span style={{ margin: "1rem 0" }}>
                        {t("Thank you for choosing CleanSky Energy")}
                      </span>
                    ),
                    component: <DeferDocumentSendingEmail />,
                  });
                }
              }
            );
          }}
        >
          {t("Continue")}
        </Button>
      </div>
    </div>
  );
};

export default DeferDocumentUpload;
